import { showNotification } from '@efacity/frontend-next-shared/notifications';
import { RightUpperMenu, setKitPurchaseProgress, setRegistrationProgress, useAuth } from '@efacity/react-next-sc';
import { displayMdUpSx } from '@efacity/common';
import { PATHS } from '@efacity/routing';
import { Box, Typography } from '@mui/material';

interface HeaderUserMenuProps {
  allowLogoutRedirect?: boolean;
}

const HeaderUserMenu = ({ allowLogoutRedirect = true }: HeaderUserMenuProps) => {
  const handleSignOut = async () => {
    try {
      await logOut();
      setRegistrationProgress(false);
      setKitPurchaseProgress(false);
      if (allowLogoutRedirect) window.location.replace(PATHS.landing);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
      showNotification(false, 'Cannot sign out', true);
    }
  };
  const gotoToPath = async (path: string) => {
    window.location.href = path;
  };
  const {
    logOut,
    authState: { workingAccessId, user, extraAuthInfo }
  } = useAuth();
  const startRegistrationURL = extraAuthInfo?.startRegistrationURL || undefined;

  return (
    <>
      <Box sx={displayMdUpSx}>
        <Typography variant="body2" color="primary" data-testid="leftName">
          {user?.email}
        </Typography>
      </Box>
      <RightUpperMenu
        user={user}
        onLogoutClick={handleSignOut}
        startRegistrationURL={startRegistrationURL}
        workingAccessId={workingAccessId || ''}
        gotoToPath={gotoToPath}
      />
    </>
  );
};

export default HeaderUserMenu;
